import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import "core-js/modules/es.array.push.js";
import { mapGetters } from 'vuex';
import { getProductDetails } from '@/api/modules/personal.js';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  name: 'function-list',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    componentType: {
      type: String
    }
  },
  data() {
    return {
      componentUrlList: [],
      // 组件详情地址
      List: [],
      // 组件列表
      activeKey: '',
      // 组件标识
      loading: false,
      listLen: 0,
      // 列表数据长度
      mySwiper: null,
      // swiper插件容器
      count: 1,
      // 控制页面初始化加载一次
      imgSwiper: null,
      isPC: false // 是否为pc产品
    };
  },
  computed: {
    ...mapGetters(['userCode', 'code'])
  },
  watch: {
    list: {
      handler(n) {
        if (n) {
          this.List = n;
          this.listLen = Math.ceil(this.List.length / 9);
          if (this.componentType === this.code && this.count <= 1) {
            this.activeKey = this.componentType + this.List[0]._id;
            this.getImage(this.List[0]._id);
            this.count++;
          }
          this.$nextTick(() => {
            if (this.mySwiper) {
              this.mySwiper.destroy();
            }
            this.mySwiper = new Swiper('.swiper-container', {
              observer: true,
              // 修改swiper自己或子元素时，自动初始化swiper
              observeParents: true,
              // 修改swiper的父元素时，自动初始化swiper
              direction: 'vertical',
              // loop: this.listLen > 1,
              loop: false,
              mousewheel: true,
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              },
              on: {
                click() {
                  return;
                }
              }
            });
          });
        }
      },
      deep: true
    },
    componentUrlList: {
      handler(n) {
        if (n) {
          this.$nextTick(() => {
            if (this.imgSwiper) {
              this.imgSwiper.destroy();
            }
            this.imgSwiper = new Swiper('.swiper-container-img', {
              observer: true,
              // 修改swiper自己或子元素时，自动初始化swiper
              observeParents: true,
              // 修改swiper的父元素时，自动初始化swiper
              loop: true,
              pagination: {
                el: '.swiper-pagination-img',
                clickable: true
              }
            });
          });
        }
      },
      deep: true
    }
  },
  methods: {
    viewDetail(item, type, component) {
      /* 获取登录状态 */
      let hasLogin = false; // 登录状态
      if (localStorage.getItem('vuex')) {
        // 获取登录状态
        const users = JSON.parse(localStorage.getItem('vuex') || '');
        hasLogin = users.user.hasLogin;
      }
      // 已登录
      if (type === 'img') {
        this.activeKey = this.componentType + item._id;
        this.getImage(item._id);
      } else {
        if (hasLogin && this.userCode) {
          localStorage.removeItem('count');
          sessionStorage.setItem('component', JSON.stringify({
            id: item._id,
            key: component
          }));
          this.$router.push({
            path: '/service/details',
            query: {
              type: 'component',
              _id: item._id,
              group_code: component
            }
          });
        } else {
          hasLogin && !this.userCode ? _message.warning('亲，您的账号出现异常，请退出登录') : _message.warning('亲，请您先登录再查看');
        }
      }
    },
    async getImage(code) {
      this.loading = true;
      await getProductDetails({
        _id: code
      }).then(res => {
        if (res.code === 1) {
          var _res$result;
          this.loading = false;
          this.componentUrlList = [];
          if (((_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.component_pictures.length) > 0) {
            var _res$result2;
            this.componentUrlList = (_res$result2 = res.result) === null || _res$result2 === void 0 ? void 0 : _res$result2.component_pictures;
            this.isPC = false;
          } else {
            if (code === '63075eb89357c52fa1eea484' || code === '630c57f49357c5d2b91dbb78') {
              this.isPC = true;
            }
          }
        }
      });
    }
  }
};